// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{overflow-x:auto}.blue-link{color:#04afef}.text-center{text-align:center}.input-title{font-size:18px;margin:16px 0}.input-title-smaller{font-size:16px;margin:8px 0}@media (max-width:968px){.container{padding-left:30px!important;padding-right:30px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
